import { keycloakConfigDevelopment } from './keycloak/keycloak.config.development';

export const environment = {
  production: false,
  apiUrl: 'https://luftborn-dss-develop-api.azurewebsites.net/api/',
  chargebeeSite: 'luftborn-pay-test',
  keycloak: keycloakConfigDevelopment,
  formsUrl: 'https://luftborn-dss-develop-forms-portal.azurewebsites.net/',
};
